import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useCart } from '~/composables/useCart';
import { useProduct } from '~/composables/_next/useProduct';
import { useToaster } from '~/composables/_next/useToaster';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useUser } from '~/composables/_next/useUser';
export function useWorkshop() {
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app;
  var router = useRouter();
  var _useGetTranslations = useGetTranslations(),
    translate = _useGetTranslations.translate;
  var _useToaster = useToaster(),
    showToast = _useToaster.show;
  var _useProduct = useProduct('workshop'),
    searchProduct = _useProduct.search,
    itemProducts = _useProduct.products;
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var _useCart = useCart(),
    addWorkshopToCart = _useCart.addWorkshopToCart,
    cart = _useCart.cart,
    hasWorkshopsInCart = _useCart.hasWorkshopsInCart,
    addItemsToCart = _useCart.addItemsById;
  var _useUiState = useUiState(),
    handleLoginNavigation = _useUiState.handleLoginNavigation;
  var savedCart = useCookie('workshop-saved-cart');

  /**
   * Determines whether the specified workshop identifier is in the current cart.
   *
   * @param      {string}   workshopId  The workshop identifier
   * @return     {Boolean}  True if the specified workshop identifier is in the current cart, False otherwise.
   */
  function isWorkshopInCurrentCart(workshopId) {
    var _cart$value;
    if (!(cart !== null && cart !== void 0 && (_cart$value = cart.value) !== null && _cart$value !== void 0 && _cart$value.id)) {
      return false;
    }
    return cart.value.lineItems.findIndex(function (product) {
      return product.variant.sku === workshopId;
    }) !== -1;
  }

  /**
   * Determines whether the specified workshop identifier is present in commercetools.
   *
   * @param      {string}            workshopId  The workshop identifier
   * @return     {Promise<Boolean>}  True if the specified workshop identifier is present in commercetools, False otherwise.
   */
  function isWorkshopInCommercetools(_x) {
    return _isWorkshopInCommercetools.apply(this, arguments);
  }
  /**
   * Check the validity of the booking data and add it to the cart
   *
   * @param      {BooxiData}         data    The booking data
   * @return     {Promise<Boolean>}  True if added to the cart, false otherwise
   */
  function _isWorkshopInCommercetools() {
    _isWorkshopInCommercetools = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(workshopId) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return searchProduct({
              skus: [workshopId]
            });
          case 2:
            return _context.abrupt("return", itemProducts.value.length > 0);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _isWorkshopInCommercetools.apply(this, arguments);
  }
  function checkAndAddWorkshopToCart(_x2) {
    return _checkAndAddWorkshopToCart.apply(this, arguments);
  }
  function _checkAndAddWorkshopToCart() {
    _checkAndAddWorkshopToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
      var isInCart, isInCommercetools, toast, _data$payment, path;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(data.bookNowStatus === 'Abort')) {
              _context2.next = 3;
              break;
            }
            clearSavedCart();
            return _context2.abrupt("return");
          case 3:
            isInCart = isWorkshopInCurrentCart(data.items[0].productId);
            if (!isInCart) {
              _context2.next = 8;
              break;
            }
            showToast({
              title: translate('workshopReservation.titleToastErrorSameWorkshop'),
              description: translate('workshopReservation.descriptionToastErrorSameWorkshop'),
              iconName: 'chat'
            }, 11000);
            clearSavedCart();
            return _context2.abrupt("return");
          case 8:
            _context2.next = 10;
            return isWorkshopInCommercetools(data.items[0].productId);
          case 10:
            isInCommercetools = _context2.sent;
            toast = {
              _id: 'workshop-country',
              title: translate('workshopReservation.titleToastErrorNotInCommercetools')
            };
            if (!isInCommercetools) {
              _context2.next = 26;
              break;
            }
            _context2.prev = 13;
            _context2.next = 16;
            return addWorkshopToCart({
              productId: data.items[0].productId,
              bookingId: data.bookingId,
              paymentId: (_data$payment = data.payment) === null || _data$payment === void 0 ? void 0 : _data$payment.onlinePaymentId,
              startDate: data.startsOn,
              attendee: data.clientCount
            });
          case 16:
            path = app.localePath({
              name: 'checkout-workshop'
            });
            router.push(app.localePath({
              name: 'checkout-workshop'
            }));
            _context2.next = 24;
            break;
          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](13);
            showToast(toast, 5000);
            console.error(_context2.t0);
          case 24:
            _context2.next = 27;
            break;
          case 26:
            showToast(toast, 5000);
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[13, 20]]);
    }));
    return _checkAndAddWorkshopToCart.apply(this, arguments);
  }
  function saveCart(products) {
    savedCart.value = products;
  }
  function restoreSavedCart() {
    return _restoreSavedCart.apply(this, arguments);
  }
  function _restoreSavedCart() {
    _restoreSavedCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _cart$value2, _cart$value2$lineItem;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(savedCart.value && !hasWorkshopsInCart.value && (!cart.value || ((_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : (_cart$value2$lineItem = _cart$value2.lineItems) === null || _cart$value2$lineItem === void 0 ? void 0 : _cart$value2$lineItem.length) === 0))) {
              _context3.next = 4;
              break;
            }
            _context3.next = 3;
            return addItemsToCart({
              productList: savedCart.value
            });
          case 3:
            clearSavedCart();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _restoreSavedCart.apply(this, arguments);
  }
  function clearSavedCart() {
    savedCart.value = null;
  }
  return {
    checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
    saveCart: saveCart,
    restoreSavedCart: restoreSavedCart,
    clearSavedCart: clearSavedCart
  };
}